export const COMMON_LOGGEDOUT = 'iam/redux/commonTypes/COMMON_LOGGEDOUT'